import React from "react";
import { DashboardBanner, DashboardPrograms } from "..";
import { PageLayout } from "shared";

export const LandingPage = () => {
  return (
    <PageLayout
      isBreadCrumbsRequired={false}
      isBreadCrumbsMarginRequired={false}
    >
      <div className="content-container">

        <div className="main-section">
          <DashboardPrograms />
        </div>

        <div className="banner-section">
          <DashboardBanner />
        </div>

      </div>
    </PageLayout>
  );
};
